module.exports = __webpack_public_path__ + "static/media/backgroundBig.04d16651.jpg";